import React from "react";
const PHONE_NUMBER = "+905"; // başına +90 koy

const CallAction = () => {
  return (
    <div className="call-to-action-wrapper call-to-action text-white-wrapper  ptb--120">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="inner text-center">
              <span>SORULARINIZ MI VAR?</span>
              <h2>Bizimle iletişime geçin</h2>
              <a className="rn-button-style--2" href={`tel:${PHONE_NUMBER}`}>
                <span>Bizi Arayın</span>
              </a>
              <div className="col-lg-12">
                <div className="copyright-text">
                  <p>
                    Copyright © 2026 acarelektrikfethiye. All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CallAction;
